


// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// Third Party
import dayjs, { UnitType } from 'dayjs';
import 'dayjs/locale/es';

// Models
import Bill, { TransactionType, TransactionTypeLiterals } from '@/manager/billing/models/bill.model';
import BillLine from '@/manager/billing/models/bill-line.model';
import { Client } from '@/manager/client/client.model';

// Constants
import Assets from '@/constants/assets.ts';
import Constants from '@/constants/constants.ts';

// Components
import Modal, { ModalTitleColor } from '@/shared/components/Modal.component.vue';
import Btn, { BtnColor, BtnWidth, BtnPredefinedStyle } from '@/shared/components/btn.component.vue';
import CheckIcon, { CheckIconColor } from '@/shared/components/CheckIcon.component.vue';
import GroupButton from '@/shared/components/group-button.component.vue';
import Field from '@/shared/components/field.component.vue';
import FieldSet from '@/shared/components/field-set.component.vue';
import { IconEnum } from '@/shared/components/icon.component.vue';
import Input, { InputSize, InputType } from '@/shared/components/input.component.vue';
import SearchAutocomplete from '@/shared/components/SearchAutocomplete.component.vue';
import TextArea from '@/shared/components/text-area.component.vue';
import TopModal from '@/shared/components/TopModal.component.vue';
import FlatSelectorText, {
    FlatSelectorTextPredefinedStyle,
    FlatSelectorTextBorderBottom,
    FlatSelectorTextWeight,
    FlatSelectorTextSize,
} from '@/shared/components/FlatSelectorText.component.vue';
import Checkbox, { CheckboxPredefinedStyle } from '@/shared/components/checkbox.component.vue';
import InlineSpinner, { SpinnerSize } from '@/shared/components/inline-spinner.component.vue';
import Dropdown, {
    DropdownWidth,
    DropdownStyle
} from "@/shared/components/Dropdown.component.vue";
import SpotlightText from '@/shared/components/SpotlightText.component.vue';

// Views
import ShoppingCartBill from '@/manager/billing/views/edit-bill-modal/shopping-cart/index.vue';
import ClientPartial from '@/manager/billing/views/edit-bill-modal/client-partial/index.vue';
import ProviderPartial from '@/manager/billing/views/edit-bill-modal/provider-partial/index.vue';

// Mixins
import SearchMixin from '@/shared/mixins/search.mixin.ts';
import ErrorMixin from '@/shared/mixins/error.mixin.ts';
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';

// Services
import BillingService from '@/manager/billing/billing.service';
import UtilsService from '@/core/services/utils.service';
import { ConvocationService, TypeOfProduct } from '@/manager/convocation/convocation.service';
import ClientService from '@/manager/client/client.service';

interface MixinInterface extends ErrorMixin, SearchMixin, NotificationMessage { }

@Component({
    components: {
        Btn,
        CheckIcon,
        ClientPartial,
        GroupButton,
        Field,
        FieldSet,
        FlatSelectorText,
        InlineSpinner,
        Input,
        SearchAutocomplete,
        ShoppingCartBill,
        TextArea,
        TopModal,
        Modal,
        ProviderPartial,
        Dropdown,
        Checkbox,
        SpotlightText,
    },
    methods: {
        ...mapActions({
            setCurrentBill: 'setCurrentBill',
        }),
    },
    computed: {
        ...mapGetters({
            getProfile: 'getProfile',
            clientList: 'getClientList',
            getClient: 'getClient',
            getProvider: 'getProvider',
            getPermissions: 'getPermissions',
            internalBusinessList: 'getInternalBusinessList',
            providerList: 'getProviderList',
            getProduct: 'getProduct',
            bill: 'getCurrentBill',
            editingBill: 'editingCurrentBill',
            hasLineProduct: 'currentBillHasLineProduct',
            receivedBillHasLineProduct: 'currentBillReceivedHasLineProduct',
            acquiredCourses: 'acquiredCoursesList',
        }),
    },
})
export default class EditBillModal extends Mixins<MixinInterface>(ErrorMixin, SearchMixin, NotificationMessage) {
    @Prop() private id!: string;
    @Prop({ default: undefined }) private purchaseBill!: object
    @Prop({ default: true }) private opened!: boolean;
    @Prop({ default: false }) private modifyDataPrivateModal!: boolean;

    private assets = Assets;
    private btnColor = BtnColor;
    private btnWidth = BtnWidth;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private iconEnum = IconEnum;
    private inputSize = InputSize;
    private inputType = InputType;
    private checkIconColor = CheckIconColor;
    private spinnerSize = SpinnerSize;
    private utilsService = UtilsService;
    private clientService = ClientService;
    private dropdownWidth = DropdownWidth;
    private DropdownStyle = DropdownStyle;
    private checkboxPredefinedStyle = CheckboxPredefinedStyle;
    private modalTitleColor = ModalTitleColor;
    private getProfile!: any;
    private lastNoteTyped: string = '';
    private lastTextTyped: string = '';
    // private noteType: number = 0; //nota:0, texto:1
    private acquiredCourses!: any;
    private clientList!: Client[];
    private providerList!: any[];
    private getProcedencyList !: any;
    private delegationList !: any;
    private getProduct !: any;
    private editingBill !: any;
    private bill !: any;
    private hasLineProduct !: any;
    private receivedBillHasLineProduct !: any;
    private setCurrentBill !: any;
    private getClient !: any;
    private getProvider !: any;
    private getDelegation !: any;
    private newClient: Client = new Client();
    private nifMask = '';
    private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
    private flatSelectorTextBorderBottom = FlatSelectorTextBorderBottom;
    private flatSelectorTextWeight = FlatSelectorTextWeight;
    private flatSelectorTextSize = FlatSelectorTextSize;
    private procedencyOptions: any = [];
    private procedencySelected: any = {};
    private procedencyOption: any = {
        value: '0',
        label: '',
    };
    private serverError = '';
    public error = {
        delegation: '',
        fiscalData: {
            postalCode: "",
            nif: "",
            firstName: "",
            lastName: "",
            email: "",
        }
    };
    private requestPending = false;
    private searchOptionSelected = undefined;
    public seriesList = [
        { 'name': 'VO/', 'id': 14 },
        { 'name': 'ASECOURSE/', 'id': 13 },
        // { 'name': 'ASECONF/', 'id': 12 },
        // {'name': 'ASEE/', 'id': 11}, 
        { 'name': 'CONF/', 'id': 10 },
        { 'name': 'COURSE/', 'id': 9 },
        // {'name': 'E/', 'id': 8}, 
        // {'name': 'D/', 'id': 7}
        { 'name': 'GRUP/', 'id': 15 },
        { 'name': 'IVGRUP/', 'id': 16 },
        { 'name': 'CUBX/', 'id': 17 },
        { 'name': 'IVCUBX/', 'id': 18 },
        { 'name': 'M/', 'id': 19 },
        { 'name': 'REF/', 'id': 20 },
        { 'name': 'FUND/', 'id': 21 },
        { 'name': 'T/', 'id': 22 },
    ]
    // public seriesList = [{'name': 'CONFERENCIA', 'id': '1'}, {'name': 'CURSOS', 'id': '2'}, {'name': 'EMITIDAS', 'id': null}]
    // public internalBusinessList = [{'name': 'LEVEL UP DESARROLLO PROFESIONAL, S.L.U.', 'id': '4'}, {'name': 'ASESORAMIENTO A EMPRESAS LEVEL UP, S.L.', 'id': '5'}, {'name': 'GESTIÓN INTERNA', 'id': '6'}, {'name': 'TLP ANTIGÜO', 'id': '7'}, {'name': 'Todas las empresas', 'id': ''}]
    public originList = [{ 'name': 'Compra', 'id': 1 }, { 'name': 'Alta(tarifa)', 'id': 2 }];
    public internalBusinessList !: any;
    private fiscalData = {
        'user': '',
        'email': '',
        'address': '',
        'postalCode': '',
        'country': '',
        'town': '',
        'state': '',
        'firstName': '',
        'lastName': '',
        'secondLastName': '',
        'nif': '',
        'phone': ' ',
        'id': '',
        'isDefault': false
    };
    private isNewFiscalDataExtension = false;
    private updateFiscalDataExtension = false;
    private isDefaultFiscalData = true;
    private productTypeSelected = this.fiscalDataExtensionsList[0];
    private budgetList: any = [];
    private disableSendForm = false;
    private selectNewFiscalData: any;
    private cambioDatosTextoConfirmacion: string = "La factura se ha cambiado. La recibirás por email. Gracias."
    private cambioDatosModalOpened1 = false;
    private cambioDatosModalOpened2 = false;
    private editarDatosModalOpened = false;
    private searchStringFiscalData = "";
    private searchNifStringAux = "";
    private selectedOptionFiscalData!: any;
    private selectedClientFiscalData!: any
    private rescatarFiscalDataBool = false;
    private searchFiscalDataExtensionsList: any = [];
    private clientCountryList: any = [];
    private clientProvinceList: any = [];
    private clientPostalCodeList: any = [];
    private changeDataUseCopyFiscalData: boolean = false;
    private zipcodes: any;
    private updateKey: any;
    private disableSendButton: boolean = false;

    get provinceSelected() {
        const provinceId: any = this.fiscalData.state;
        let result = {
            value: "",
            label: ""
        };

        if (provinceId != 'SIN DATOS' && typeof provinceId === "string") {
            result = this.clientProvinceList.find((option: any) => {
                return option.value === provinceId;
            });
        } else if (typeof provinceId === 'object' && provinceId !== null && provinceId.value) {
            result = this.clientProvinceList.find((option: any) => {
                return option.value === provinceId.value;
            });
        }

        this.fetchPostalCodeList(provinceId);
        return result;
    }

    get countrySelected() {
        const countryId:any = this.fiscalData.country;
        let result = {
            value: "",
            label: ""
        };

        if (countryId != 'SIN DATOS' && typeof countryId === "string") {
            result = this.clientCountryList.find((option: any) => {
                return option.value === countryId;
            });
        } else if (typeof countryId === 'object' && countryId !== null && countryId.value) {
            result = this.clientCountryList.find((option: any) => {
                return option.value === countryId.value;
            });
        }

        // this.fetchPostalCodeList(countryId);
        return result;
    }

    @Watch("searchStringFiscalData")
    public watchsearchStringFiscalData(newVal: any, oldVal: any) {

        if (this.searchTimeout != null) {
            clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
            this.searchFDCallback();
        }, 1000);

    }

    @Watch('purchaseBill')
    private watchPurchaseBill(newVal: any, oldVal: any) {
        // this.setCurrentBill(newVal)
        this.fetchBill(newVal.id)
    }

    @Watch('opened')
    private watchOpened(newVal: any, oldVal: any) {
        this.acquiredCourses = undefined
        if (this.purchaseBill == undefined) {
            this.checkFillModalWithBillData();
        }
    }

    @Watch('serverError')
    private watchServerError(newVal: any, oldVal: any) {
        if (newVal != this.cambioDatosTextoConfirmacion) {
            setTimeout(() => {
                this.serverError = '';
            }, Constants.notificationMessageTimeToAppear);
        }
    }

    get fiscalDataExtensionsList(): any[] {
        return [
            { nif: 'Seleccione' },
            { nif: 'Avenida Gabriel Roca, 8, piso 3' },
            { nif: 'Calle Rafel Rodriguez Mendez, 1, piso 2A' },
        ];
    }

    // get budgetList(): any[] {
    //     let budgetList:any = [];
    //     //cosas
    //     return budgetList;
    // }


    @Watch("productTypeSelected")
    private watchProductTypeSelected(newVal: any, oldVal: any) {
        this.isNewFiscalDataExtension = false;
        this.isDefaultFiscalData = false;
        this.fiscalData = {
            'user': newVal.userId,
            'email': newVal.email || 'SIN@DATOS.COM',
            'address': newVal.address || 'SIN DATOS',
            'postalCode': newVal.postalCode,
            'country': newVal.country || 'SIN DATOS',
            'town': newVal.town || 'SIN DATOS',
            'state': newVal.state || 'SIN DATOS',
            'firstName': newVal.firstName || 'SIN DATOS',
            'lastName': newVal.lastName || 'SIN DATOS',
            'secondLastName': newVal.secondLastName || 'SIN DATOS',
            'nif': newVal.nif,
            'phone': newVal.phone || '34',
            'id': newVal.id,
            'isDefault': false
        }

        this.bill.fiscalData = undefined;
        this.bill.fiscalDataExtension = this.fiscalData.id;
    }

    @Watch("acquiredCourses")
    private setProductTypeSelected(newVal: any, oldVal: any) {
        this.rescatarFiscalDataBool = false;
        if (this.acquiredCourses && this.acquiredCourses.fiscalDataExtensions && this.acquiredCourses.fiscalDataExtensions.length > 0 && this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault)[0]) {
            this.checkCurrentFiscalDataExtension()
            if (this.selectNewFiscalData) {
                this.productTypeSelected = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.id == this.selectNewFiscalData)[0];
                this.selectNewFiscalData = undefined
            } else {
                this.productTypeSelected = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault)[0];
            }
            this.bill.fiscalData = this.fiscalData;
            this.bill.fiscalDataExtensionId = this.fiscalData.id;
        } else {
            this.productTypeSelected = this.fiscalDataExtensionsList[0];
        }
    }

    private checkCurrentFiscalDataExtension() {
        if (this.fiscalData.id == '' || this.fiscalData.user == '') {
            this.setCurrentFiscalDataExtension()
        }
    }

    private setCurrentFiscalDataExtension() {
        // this.updateFiscalDataExtension = true;
        let defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault);
        if (this.isDefaultFiscalData) {
            if (defaultExtension.length > 0) {
                this.fiscalData = {
                    'user': this.acquiredCourses.userId,
                    'email': this.acquiredCourses.fiscalData.email || 'SIN@DATOS.COM',
                    'address': this.acquiredCourses.fiscalData.address || 'SIN DATOS',
                    'postalCode': this.acquiredCourses.fiscalData.postalCode,
                    'country': this.acquiredCourses.fiscalData.country || 'SIN DATOS',
                    'town': this.acquiredCourses.fiscalData.town || 'SIN DATOS',
                    'state': this.acquiredCourses.fiscalData.state || 'SIN DATOS',
                    'firstName': this.acquiredCourses.fiscalData.firstName || 'SIN DATOS',
                    'lastName': this.acquiredCourses.fiscalData.lastName || 'SIN DATOS',
                    'secondLastName': this.acquiredCourses.fiscalData.secondLastName || 'SIN DATOS',
                    'nif': this.acquiredCourses.fiscalData.nif,
                    'phone': this.acquiredCourses.fiscalData.phone || 'SIN DATOS',
                    'id': defaultExtension[0].id,
                    'isDefault': true
                }
            } else {
                this.fiscalData = {
                    'user': this.acquiredCourses.userId,
                    'email': this.acquiredCourses.fiscalData.email || 'SIN@DATOS.COM',
                    'address': this.acquiredCourses.fiscalData.address || 'SIN DATOS',
                    'postalCode': this.acquiredCourses.fiscalData.postalCode,
                    'country': this.acquiredCourses.fiscalData.country || 'SIN DATOS',
                    'town': this.acquiredCourses.fiscalData.town || 'SIN DATOS',
                    'state': this.acquiredCourses.fiscalData.state || 'SIN DATOS',
                    'firstName': this.acquiredCourses.fiscalData.firstName || 'SIN DATOS',
                    'lastName': this.acquiredCourses.fiscalData.lastName || 'SIN DATOS',
                    'secondLastName': this.acquiredCourses.fiscalData.secondLastName || 'SIN DATOS',
                    'nif': this.acquiredCourses.fiscalData.nif,
                    'phone': this.acquiredCourses.fiscalData.phone || 'SIN DATOS',
                    'id': '',
                    'isDefault': true
                }
            }
        }
    }

    private setProvince() {
        setTimeout(() => {
            let result = this.clientPostalCodeList.find((option: any) => {
                return option.value.slice(0, 2) === this.fiscalData.postalCode.slice(0, 2);
            });

            if (this.fiscalData.postalCode.length == 5) {
                let zipCodesResults = this.zipcodes.filter((zipcode: any) => zipcode.zipcode === this.fiscalData.postalCode);
                if (zipCodesResults.length > 0) {
                    this.fiscalData.town = zipCodesResults[0].place
                }
            }

            if (result) {
                this.fiscalData.country = result.country;
                this.fiscalData.state = result.province;
            }
        }, 1000);
    }

    private fetchProvinceList() {
        this.$store.dispatch("fetchClientProvinceList").then((res) => {
            this.clientProvinceList = res.map((e: any) => {
                const option = {
                    value: e.name,
                    label: e.name,
                };
                return option;
            });
            this.updateKey++;
        });
    }

    private fetchCountryList() {
        this.$store.dispatch("fetchClientCountryList").then((res) => {
            this.clientCountryList = res.map((e: any) => {
                const option = {
                    value: e.name,
                    label: e.name,
                };
                return option;
            });
            this.updateKey++;
        });
    }

    private fetchPostalCodeList(province: any) {
        this.$store.dispatch("fetchClientPostalCodeList", /* province */).then((res) => {
            this.clientPostalCodeList = res.map((e: any) => {
                const option = {
                    value: e.name || '',
                    label: e.name || '',
                    province: e.province ? e.province.name : '',
                    country: e.province && e.province.country ? e.province.country.name : ''
                };
                return option;
            });
        });
    }

    private updateCP(province: any) {
        this.fetchPostalCodeList(province.value);
    }

    get postalCodeSelected() {
        const postalCodeId = this.bill.client.user.profile.postalCode;
        let result = {};
        if (postalCodeId) {
            result = this.clientPostalCodeList.find((option: any) => {
                return option.value === postalCodeId;
            });
        }
        return result;
    }


    private created() {
        this.initializeComponent();
    }

    private mounted() {
        this.zipcodes = this.assets.zipCodesJson
    }


    get transactionTypeOptions() {
        return [
            {
                id: String(TransactionType.TransactionEmitted),
                text: TransactionTypeLiterals[TransactionType.TransactionEmitted],
            }, {
                id: String(TransactionType.TransactionReceived),
                text: TransactionTypeLiterals[TransactionType.TransactionReceived],
            },
        ];
    }

    get searchAutocompleteNifOption() {
        const option = {
            placeholder: 'NIF',
            options: this.clientList,
            fields: { id: 'user.id', text: 'user.profile.nif' },
        };

        return option;
    }

    get searchAutocompleteOption() {
        const option = {
            placeholder: 'Busca un cliente',
            options: this.clientList,
            fields: { id: 'user.id', text: 'user.fullName' },
        };

        if (this.billIsReceived) {
            option.placeholder = 'Busca un proveedor';
            option.options = this.providerList;
            option.fields = { id: 'id', text: 'name' };
        }

        return option;
    }

    get hasSelectedClient() {
        return (this.bill.client !== null);
    }

    get lastSectionTitle() {
        let title = '';
        if (!this.editingBill) {
            title = 'Añadir nota';
        }
        return title;
    }

    get billIsEmitted() {
        return this.bill.transactionType === TransactionType.TransactionEmitted;
    }

    get billIsReceived() {
        return this.bill.transactionType === TransactionType.TransactionReceived;
    }

    get hasServerError() {
        return this.serverError !== '';
    }

    get modalTitle() {
        let title = 'Añadir factura';
        if (this.modifyDataPrivateModal) {
            title = 'Cambio datos de facturación: Bloque no editable'
        } else if (this.editingBill) {
            title = 'Editar factura';
        }
        return title;
    }

    get btnText() {
        let text = 'Añadir factura';
        if (this.modifyDataPrivateModal) {
            text = "Guardar y enviar"
        } else if (this.editingBill) {
            text = 'Guardar';
        }
        return text;
    }

    get formComplete() {
        let complete = false;
        if (this.billIsEmitted) {
            complete = (
                this.bill.client &&
                this.bill.client.user &&
                this.bill.client.user.id &&
                this.bill.internalBusiness !== undefined &&
                this.bill.billLine.length > 0 &&
                this.bill.billLine[0].product !== undefined
            );
        } else {
            complete = (
                this.bill.provider &&
                this.bill.provider.id &&
                this.bill.billLine[0].productName !== undefined &&
                this.bill.billLine[0].productAmount > 0 &&
                this.bill.billLine[0].productPrice > 0 &&
                this.bill.billLine[0].productTax > 0
            );
        }
        return complete;
    }

    get isPublicView() {
        return window.location.href.includes("/public/")
    }

    get editRefundBill() {
        if (this.bill.originBill) {
            return { 'pointer-events': 'none' }
        }
    }
    get editRefundBillParent() {
        if (this.bill.originBill) {
            return { 'cursor': 'not-allowed' }
        }
    }


    private initializeComponent() {
        if (this.id) {
            this.fetchBill(this.id);
        }

        this.remainingTime = 0;
        this.fetchInternalBusinessList();
        // this.fetchBudgetList()
        this.fetchProvinceList();
        this.fetchCountryList();
    }

    private fetchBill(billId: any) {
        this.$store.dispatch('fetchBill', { id: billId }).then(
            res => {
                this.modifyDataPrivateModal = true
                if(res.displayId.includes('R.')){
                    this.disableSendButton = true;
                    this.showMessage({message:"Factura rectificativa. Contacte con atencion al cliente.", error:true});
                } else {
                    this.setCurrentBill(res);
                    this.bill = res
                    if (res.communicationStatus != 0) {
                        this.cambioDatosModalOpened1 = true
                    } else {
                        this.editarDatosModalOpened = true
                    }
                    this.checkFillModalWithBillData()
                }
            }
        );
    }

    private fetchBudgetList(callback: any = () => { const doNothing = 1; },) {
        this.$store.dispatch('fetchBudgetList', {
            budget_id_list: true,
        }).then((res: any) => {
            this.budgetList = res;
            callback();
        });
    }

    protected searchTimeout: any = null

    public searchCallback() {
        if (this.searchTimeout != null) {
            clearTimeout(this.searchTimeout);
        }

        this.searchTimeout = setTimeout(() => {
            if (this.searchString === '') {
                this.bill.client = new Client();
            }
            if (this.billIsEmitted) {
                this.fetchClientList();
            } else {
                this.fetchProviderList();
            }
        }, 500);
    }

    private transactionTypeSelected(transactionType: string) {
        this.bill.transactionType = Number(transactionType);
        this.setCurrentBill(this.bill);
    }

    private fetchClientList() {
        const payload = {
            limit: 20,
            search: this.searchString,
            search_nif: this.searchNifString,
        };
        this.$store.dispatch('fetchClientList', payload);
    }

    private fetchProviderList() {
        const payload = {
            limit: 20,
            search: this.searchString,
            search_nif: this.searchNifString,
        };
        this.$store.dispatch('fetchProviderList', payload);
    }

    private closeModal() {
        if (this.opened) {
            this.setCurrentBill(new Bill());
            this.$emit('close-modal-edit-bill', true);
        }
    }

    private checkMandatoryFields() {
        let result = true;
        if (!this.bill.internalBusiness) {
            this.serverError = 'Se debe seleccionar una Empresa';
            result = false;
            // } else if (!this.editingBill && !this.bill.prefix) {
            //     this.serverError = 'Se debe seleccionar una serie';
            //     result = false;
        } else if (this.billIsEmitted && !this.bill.client.user.id) {
            this.serverError = 'Se debe seleccionar un cliente';
            result = false;
        } else if (this.billIsReceived && !this.bill.provider.id) {
            this.serverError = 'Se debe seleccionar un proveedor';
            result = false;
        } else if (
            (this.billIsEmitted && !this.hasLineProduct && !this.bill.originBill) ||
            (this.billIsReceived && !this.receivedBillHasLineProduct)
        ) {
            this.serverError = 'La factura debe tener al menos un producto';
            result = false;
        }

        const fiscalDataNif = (this.fiscalData as any).nif;
        if (!fiscalDataNif || fiscalDataNif === "") {
            this.error.fiscalData.nif = "Campo vacío";
            result = false;
        }

        const postalCode = (this.fiscalData as any).postalCode;
        if (!postalCode || postalCode === "") {
            this.error.fiscalData.postalCode = "Campo vacío";
            result = false;
        }

        const firstName = (this.fiscalData as any).firstName;
        if (!firstName || firstName === "" || firstName === "SIN DATOS") {
            this.error.fiscalData.firstName = "Campo obligatorio";
            result = false;
        }

        const lastName = (this.fiscalData as any).lastName;
        if (!lastName || lastName === "" || lastName === "SIN DATOS") {
            this.error.fiscalData.lastName = "Campo obligatorio";
            result = false;
        }

        const email = (this.fiscalData as any).email;
        if (!email || email === "" || email === "SIN@DATOS.COM") {
            this.error.fiscalData.email = "Campo obligatorio";
            result = false;
        }

        if (this.fiscalData && this.fiscalData.id) {
            this.updateBillDataFromFiscalDataExtension(this.fiscalData)
        }

        return result;
    }

    private setParticipantFormError(err: any) {
        const serverError = err.response.data;
        const response = err.response;
        this.requestPending = false;
        if (
            response.status === 500 ||
            (
                response.status === 400 &&
                serverError.nonFieldErrors !== undefined
            )
        ) {
            this.serverError = Constants.internalServerErrorMessage;
        }
    }

    private setIdProductInBillLines(bill: Bill, refundedOriginBill: any = undefined) {
        const newLines = (bill as any).billLine.map(
            (line: BillLine) => {
                const billLine = Object.assign({}, line);
                const productId = (billLine.product as any) ? (billLine.product as any).id : undefined;
                delete billLine.product;
                if (refundedOriginBill) {
                    delete billLine.id
                }
                return {
                    product: productId,
                    ...billLine,
                };
            },
        );
        bill.billLine = newLines;
    }

    private checkBill(refundedOriginBill: any = undefined) {
        const newBill = Object.assign({}, this.bill);
        newBill.billLine = Object.assign([], newBill.billLine);
        const billLines = (newBill as any).billLine.length;
        if (billLines > 0) {
            (newBill as any).billLine.pop();
            this.setIdProductInBillLines(newBill, refundedOriginBill);
        }
        if (this.editingBill) {
            newBill.internalBusiness = this.bill.internalBusiness.id;
        }

        if (this.billIsEmitted) {
            newBill.client = this.bill.client.user.id;
            delete newBill.provider;
        } else {
            newBill.provider = this.bill.provider.id;
            delete newBill.client;
        }

        return newBill;
    }

    private newBill(refundedOriginBill: any = undefined) {
        const bill = this.checkBill(refundedOriginBill);
        const note = { note: this.lastNoteTyped };
        let changeDataRefundedBill = undefined
        if (refundedOriginBill) {
            changeDataRefundedBill = refundedOriginBill.id
            bill.communicationStatus = 0;
        }
        this.$store.dispatch('newBill', {
            ...bill,
            note,
            changeDataRefundedBill
        }).then(
            (res) => {
                this.checkNotes(res);
                this.initializeBill();
                setTimeout(() => {
                    this.$emit('new-bill', { add: true, edit: false });
                }, 300);
                this.requestPending = false;
                if (this.modifyDataPrivateModal && this.isPublicView) {
                    this.requestPending = false
                    this.serverError = this.cambioDatosTextoConfirmacion
                }
                this.closeModal();
            },
        ).catch((err) => {
            this.setParticipantFormError(err);
        });
    }

    private updateBill() {
        const bill = this.checkBill();
        this.$store.dispatch('updateBill', { ...bill }).then(
            (res) => {
                this.checkNotes(res);
                this.initializeBill();
                setTimeout(() => {
                    this.$emit('new-bill', { add: false, edit: true });
                }, 300);
                this.requestPending = false;
                if (this.modifyDataPrivateModal && this.isPublicView) {
                    this.serverError = this.cambioDatosTextoConfirmacion
                }
                this.closeModal();
            },
        ).catch((err) => {
            this.setParticipantFormError(err);
        });
    }

    /**
     * Añadir nota/texto al crear una factura
     * @param bill 
     */
    private checkNotes(bill: any) {
        let noteType = 0;
        if (this.lastNoteTyped) {
            this.$store.dispatch('newBillNote', {
                billId: bill.id,
                employee: { user: { id: this.getProfile.id } },
                note: this.lastNoteTyped,
                type: noteType,
                mentions: []
            }).then(
                (res) => {

                },
            );
        }
        if (this.lastTextTyped) {
            noteType = 1
            this.$store.dispatch('newBillNote', {
                billId: bill.id,
                employee: { user: { id: this.getProfile.id } },
                note: this.lastTextTyped,
                type: noteType,
                mentions: []
            }).then(
                (res) => {

                },
            );
        }
    }

    private fillFiscalDataFormExistingClient() {
        let defaultExtension: any;
        let defaultFiscalData: any;
        if (this.bill) {
            defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.id == this.bill.fiscalDataExtension);
            if (defaultExtension.length == 0) {
                defaultFiscalData = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.id == this.bill.fiscalData);
            }
        } else {
            defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault);
        }

        if (defaultExtension.length > 0) {
            this.fiscalData = {
                'user': defaultExtension[0].userId,
                'email': defaultExtension[0].email,
                'address': defaultExtension[0].address,
                'postalCode': defaultExtension[0].postalCode,
                'country': defaultExtension[0].country,
                'town': defaultExtension[0].town,
                'state': defaultExtension[0].state,
                'firstName': defaultExtension[0].firstName,
                'lastName': defaultExtension[0].lastName,
                'secondLastName': defaultExtension[0].secondLastName,
                'nif': defaultExtension[0].nif,
                'phone': defaultExtension[0].phone,
                'id': defaultExtension[0].id,
                "isDefault": true
            }
            this.bill.fiscalData = undefined
            this.bill.fiscalDataExtension = this.fiscalData.id
        } else if (defaultFiscalData.length > 0) {
            this.fiscalData = {
                'user': defaultFiscalData[0].userId,
                'email': defaultFiscalData[0].email,
                'address': defaultFiscalData[0].address,
                'postalCode': defaultFiscalData[0].postalCode,
                'country': defaultFiscalData[0].country,
                'town': defaultFiscalData[0].town,
                'state': defaultFiscalData[0].state,
                'firstName': defaultFiscalData[0].firstName,
                'lastName': defaultFiscalData[0].lastName,
                'secondLastName': defaultFiscalData[0].secondLastName,
                'nif': defaultFiscalData[0].nif,
                'phone': defaultFiscalData[0].phone,
                'id': defaultFiscalData[0].userId,
                "isDefault": false
            }
            this.bill.fiscalData = this.fiscalData.id
            this.bill.fiscalDataExtension = undefined
        } else {
            this.fiscalData = {
                'user': this.acquiredCourses.userId,
                'email': this.bill.client.user.email || 'SIN@DATOS.COM',
                'address': this.bill.client.user.profile.address || 'SIN DATOS',
                'postalCode': this.bill.client.user.profile.postalCode,
                'country': this.bill.client.user.profile.country || 'SIN DATOS',
                'town': this.bill.client.user.profile.town || 'SIN DATOS',
                'state': this.bill.client.user.profile.state || 'SIN DATOS',
                'firstName': this.bill.client.user.firstName || 'SIN DATOS',
                'lastName': this.bill.client.user.lastName || 'SIN DATOS',
                'secondLastName': this.bill.client.user.secondLastName || 'SIN DATOS',
                'nif': this.bill.client.user.profile.nif,
                'phone': this.bill.client.user.profile.phone || '34',
                'id': '',
                "isDefault": true
            }
            this.isDefaultFiscalData = false;
            this.isNewFiscalDataExtension = true;
        }
    }

    private updateCurrentFiscalDataExtension() {
        this.updateFiscalDataExtension = true;
        let defaultExtension: any;
        if (this.bill) {
            defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.id == this.bill.fiscalDataExtension);
            if (defaultExtension.length == 0) {
                defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.id == this.bill.fiscalData);
            }
        } else {
            defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault);
        }
        if (this.isDefaultFiscalData) {
            if (defaultExtension.length > 0) {
                this.fiscalData = {
                    'user': this.acquiredCourses.userId,
                    'email': this.acquiredCourses.fiscalData.email || 'SIN@DATOS.COM',
                    'address': this.acquiredCourses.fiscalData.address || 'SIN DATOS',
                    'postalCode': this.acquiredCourses.fiscalData.postalCode,
                    'country': this.acquiredCourses.fiscalData.country || 'SIN DATOS',
                    'town': this.acquiredCourses.fiscalData.town || 'SIN DATOS',
                    'state': this.acquiredCourses.fiscalData.state || 'SIN DATOS',
                    'firstName': this.acquiredCourses.fiscalData.firstName || 'SIN DATOS',
                    'lastName': this.acquiredCourses.fiscalData.lastName || 'SIN DATOS',
                    'secondLastName': this.acquiredCourses.fiscalData.secondLastName || 'SIN DATOS',
                    'nif': this.acquiredCourses.fiscalData.nif,
                    'phone': this.acquiredCourses.fiscalData.phone || 'SIN DATOS',
                    'id': defaultExtension[0].id,
                    'isDefault': true
                }
            } else {
                this.fiscalData = {
                    'user': this.acquiredCourses.userId,
                    'email': this.acquiredCourses.fiscalData.email || 'SIN@DATOS.COM',
                    'address': this.acquiredCourses.fiscalData.address || 'SIN DATOS',
                    'postalCode': this.acquiredCourses.fiscalData.postalCode,
                    'country': this.acquiredCourses.fiscalData.country || 'SIN DATOS',
                    'town': this.acquiredCourses.fiscalData.town || 'SIN DATOS',
                    'state': this.acquiredCourses.fiscalData.state || 'SIN DATOS',
                    'firstName': this.acquiredCourses.fiscalData.firstName || 'SIN DATOS',
                    'lastName': this.acquiredCourses.fiscalData.lastName || 'SIN DATOS',
                    'secondLastName': this.acquiredCourses.fiscalData.secondLastName || 'SIN DATOS',
                    'nif': this.acquiredCourses.fiscalData.nif,
                    'phone': this.acquiredCourses.fiscalData.phone || 'SIN DATOS',
                    'id': '',
                    "isDefault": true
                }
            }
        }
    }

    private updateBillDataFromFiscalDataExtension(newData: any) {
        this.bill.address = newData.address
        this.bill.country = newData.country
        this.bill.email = newData.email
        this.bill.name = newData.firstName + ' ' + newData.lastName
        this.bill.nif = newData.nif
        this.bill.phone = newData.phone
        this.bill.town = newData.town
        this.bill.postalCode = newData.postalCode
    }

    private patchFiscalDataExtension(data: any, userId: any, id: any, isCopyFrom?: boolean) {
        if (this.checkMandatoryFields()) {
            this.updateFiscalDataExtension = false;
            if (isCopyFrom) {
                data.isCopyFrom = data.id;
                this.changeDataUseCopyFiscalData = true;
            }
            if (data.phone) {
                data.phone = data.phone.replaceAll(/\s/g, '');
            }
            // data = {'isDefault': data};
            data.isDefault = true;
            const payload = {
                id,
                userId,
                data,
            };

            this.$store.dispatch('newFiscalDataExtension', data).then(
                res => {
                    this.bill.fiscalData = undefined;
                    this.bill.fiscalDataExtension = res.id;
                    this.$store.dispatch("fetchAcquiredCoursesList", { id: userId })
                    this.showMessage("Datos fiscales guardados correctamente")
                    this.updateBillDataFromFiscalDataExtension(res)
                }
            ).catch((err) => {
                this.serverError = "Error al añadir fiscal data, compruebe los datos o intentelo de nuevo más tarde."
            });

            // this.$store.dispatch('patchFiscalDataExtension', payload).then(
            //     res => {
            //         this.$store.dispatch("fetchAcquiredCoursesList", { id: userId })
            //         this.updateBillDataFromFiscalDataExtension(res)
            //     }
            // );
            // setTimeout(() => {
            //     // this.fetchFiscalDataExtensionsList();
            // }, 1000);
        }
        // 2000
    }

    private addFiscalDataExtension(fiscalData: any, status?: any) {
        if (this.checkMandatoryFields()) {
            if (status) {
                fiscalData.isDefault = status
            } else if (this.acquiredCourses && this.acquiredCourses.fiscalDataExtensions && this.acquiredCourses.fiscalDataExtensions.length == 0) {
                // If is new fiscal data and it's the first one
                fiscalData.isDefault = true
            } else {
                fiscalData.isDefault = false
            }
            if (fiscalData.phone) {
                fiscalData.phone = fiscalData.phone.replaceAll(/\s/g, '');
            }
            this.isNewFiscalDataExtension = false;
            this.updateFiscalDataExtension = false;
            this.rescatarFiscalDataBool = false;
            this.$store.dispatch('newFiscalDataExtension', fiscalData).then(
                res => {
                    this.bill.fiscalData = undefined;
                    this.bill.fiscalDataExtension = res.id;
                    this.$store.dispatch("fetchAcquiredCoursesList", { id: fiscalData.user })
                    this.showMessage("Datos fiscales guardados correctamente")
                }
            ).catch((err) => {
                this.serverError = "Error al añadir fiscal data, compruebe los datos o intentelo de nuevo más tarde."
            });
        }
    }

    private patchFiscalDataDefaultExtension(data: any, userId: any, id: any) {
        if (this.checkMandatoryFields()) {
            this.updateFiscalDataExtension = false;
            // data = {'isDefault': data};
            data.isDefault = true;
            if (data.phone) {
                data.phone = data.phone.replaceAll(/\s/g, '');
            }
            const payload = {
                id,
                userId,
                data,
            };
            this.$store.dispatch('patchFiscalDataExtension', payload).then(
                res => {
                    this.$store.dispatch("fetchAcquiredCoursesList", { id: userId })
                    this.showMessage("Cambios realizados correctamente")
                }
            );
            setTimeout(() => {
                // this.fetchFiscalDataExtensionsList();
            }, 1000);
        }
        // 2000
    }

    private showMessage(message: any) {
        let color = this.ownSpotlightTextColor.Primary;
        let text = message;
        if (message.error) {
            color = this.ownSpotlightTextColor.Error;
        }
        if (message.message) {
            text = message.message;
        }
        this.showNotification(text, color);
    }

    private fetchAquiredCourses() {
        if (this.bill.client && this.bill.client.user && this.bill.client.user.id) {
            return this.$store.dispatch("fetchAcquiredCoursesList", {
                id: this.bill.client.user.id
            }).then(() => {
                this.fillFiscalDataFormExistingClient();
            });
        }
    }

    private newFiscalDataExtension() {
        this.updateFiscalDataExtension = false;
        this.isDefaultFiscalData = false;
        this.isNewFiscalDataExtension = true;
        this.fiscalData = {
            'user': this.acquiredCourses.userId,
            'email': 'SIN@DATOS.COM',
            'address': 'SIN DATOS',
            'postalCode': '',
            'country': 'SIN DATOS',
            'town': 'SIN DATOS',
            'state': 'SIN DATOS',
            'firstName': 'SIN DATOS',
            'lastName': 'SIN DATOS',
            'secondLastName': 'SIN DATOS',
            'nif': '',
            'phone': '+34',
            'id': '',
            'isDefault': false
        }
    }

    private getFormattedDate() {
        const today = new Date();
        const isoString = today.toISOString();
        return isoString;
    }


    private handleSaveEvent() {
        this.disableSendForm = true
        if (this.modifyDataPrivateModal && this.bill.communicationStatus != 0) {
            this.requestPending = true
            this.billRefund()
        } else {
            this.sendForm()
        }
    }


    private billRefund() {
        if (this.checkMandatoryFields()) {
            // set today date to new bill
            this.bill.useCopyFiscalData = this.changeDataUseCopyFiscalData; //TODO check this, not used
            this.bill.date = this.getFormattedDate()
            BillingService.refundBill(this.bill.id, this.bill).then(
                (res) => {
                    this.newBill(res.data)
                }
            ).catch((err) => {
                this.requestPending = false
                this.serverError = "Ha habido un problema, intentelo de nuevo más tarde."
            })
        }
    }


    private sendForm() {
        if (this.checkMandatoryFields()) {
            this.requestPending = true;
            if (this.editingBill) {
                this.updateBill();
            } else {
                this.newBill();
            }
        }
    }

    private selectOption(option: any) {
        if (this.billIsEmitted) {
            this.bill.client = this.getClient(option.id);
            // this.fetchFiscalData()
            this.fetchAquiredCourses()
        } else {
            this.bill.provider = this.getProvider(option.id);
        }
    }

    private clearSearchInput() {
        if (this.billIsEmitted) {
            this.clearClient();
        } else {
            this.clearProvider();
        }
        this.clearFiscalData()
    }

    private clearClient() {
        this.searchString = '';
        this.searchNifString = '';
        this.bill.client = new Client();
        this.setCurrentBill(this.bill);
    }

    private clearProvider() {
        // TODO
    }

    private clearFiscalData() {
        this.fiscalData = {
            'user': '',
            'email': '',
            'address': '',
            'postalCode': '',
            'country': '',
            'town': '',
            'state': '',
            'firstName': '',
            'lastName': '',
            'secondLastName': '',
            'nif': '',
            'phone': ' ',
            'id': '',
            'isDefault': false
        };
        this.isNewFiscalDataExtension = false;
        this.isDefaultFiscalData = true;
        this.updateFiscalDataExtension = false;
        this.productTypeSelected = this.fiscalDataExtensionsList[0];
        this.acquiredCourses = undefined
    }

    private initializeBill() {
        this.setCurrentBill(new Bill());
        this.clearSearchInput();
        this.lastNoteTyped = '';
        this.lastTextTyped = '';
    }

    private checkAddEmptyBillLine() {
        const lines = (this.bill as any).billLine;
        const linesLength = lines.length;
        if (linesLength && lines[linesLength - 1].id) {
            const newLine = new BillLine();
            lines.push(newLine);
        }
    }

    private setBillLineProductObject() {
        (this.bill as any).billLine.forEach((line: any) => {
            if (!line.product) {
                // console.log(this.getProduct(line.product));
                line.product = this.getProduct(line.product);
            }
        });
        this.checkAddEmptyBillLine();
    }

    private checkFillModalWithBillData() {
        if (this.opened && this.editingBill) {
            this.newClient = (this.bill.client as any);
            this.setBillLineProductObject();
            this.fetchAquiredCourses();
        } else if (this.opened && !this.editingBill) {
            this.newClient = new Client();
        }
    }

    private updateStoredBill() {
        if (this.bill.internalBusiness.id) {
            this.bill.internalBusiness = this.bill.internalBusiness.id;
        }
        this.setCurrentBill(this.bill);
    }

    private updateStoredSerie() {
        this.bill.prefix = this.bill.prefix.id;
        this.setCurrentBill(this.bill);
    }

    private updateStoredOriginName() {
        this.bill.originName = this.bill.originName.id;
        this.setCurrentBill(this.bill);
    }

    private fetchInternalBusinessList(callback: any = () => { const doNothing = 1; }) {
        this.$store.dispatch('fetchInternalBusinessList').then((res: any) => {
            callback();
        });
    }

    private cambioDatosModal1(value: boolean) {
        this.cambioDatosModalOpened1 = value;
        if (!value) {
            this.cambioDatosModal2(true);
        }
    }

    private cambioDatosModal2(value: boolean) {
        this.cambioDatosModalOpened2 = value;
    }

    private editarDatosModal(value: boolean) {
        this.editarDatosModalOpened = value;
    }

    private duplicateFiscalDataExtension() {
        this.fiscalData = {
            'user': this.acquiredCourses.userId,
            'email': this.bill.client.user.email || 'SIN@DATOS.COM',
            'address': this.bill.client.user.profile.address || 'SIN DATOS',
            'postalCode': this.bill.client.user.profile.postalCode,
            'country': this.bill.client.user.profile.country || 'SIN DATOS',
            'town': this.bill.client.user.profile.town || 'SIN DATOS',
            'state': this.bill.client.user.profile.state || 'SIN DATOS',
            'firstName': this.bill.client.user.firstName || 'SIN DATOS',
            'lastName': this.bill.client.user.lastName || 'SIN DATOS',
            'secondLastName': this.bill.client.user.secondLastName || 'SIN DATOS',
            'nif': this.bill.client.user.profile.nif,
            'phone': this.bill.client.user.profile.phone || '34',
            'id': '',
            'isDefault': true
        }
    }

    get searchAutocompletePlaceholder() {
        return "Buscar datos fiscales";
    }

    public searchFDCallback() {
        if (this.searchStringFiscalData === "") {
            this.selectedOptionFiscalData = null;
        }
        this.fetchClientFiscalDataExtension();
    }

    private fetchClientFiscalDataExtension() {
        const payload = {
            limit: 20,
            search: this.searchStringFiscalData
        };
        this.$store.dispatch("fetchFiscalDataExtension", payload)
            .then((res) => {
                this.searchFiscalDataExtensionsList = res.results
            });;
    }

    private selectFiscalData(option: any, modifyPurchase?: any, index?: any) {
        this.selectedOptionFiscalData = option;
        this.selectedClientFiscalData = this.searchFiscalDataExtensionsList.filter((item: any) => item.id == this.selectedOptionFiscalData.id)[0]

        if (this.selectedClientFiscalData) {
            this.fiscalData = {
                'user': this.bill.client.user.id,
                'email': this.selectedClientFiscalData.email || 'SIN@DATOS.COM',
                'address': this.selectedClientFiscalData.address || 'SIN DATOS',
                'postalCode': this.selectedClientFiscalData.postalCode,
                'country': this.selectedClientFiscalData.country || 'SIN DATOS',
                'town': this.selectedClientFiscalData.town || 'SIN DATOS',
                'state': this.selectedClientFiscalData.state || 'SIN DATOS',
                'firstName': this.selectedClientFiscalData.firstName || 'SIN DATOS',
                'lastName': this.selectedClientFiscalData.lastName || 'SIN DATOS',
                'secondLastName': this.selectedClientFiscalData.secondLastName || 'SIN DATOS',
                'nif': this.selectedClientFiscalData.nif,
                'phone': this.selectedClientFiscalData.phone || '34',
                'id': '',
                "isDefault": true
            }
        }
    }

    private rescatarFiscalDataExtension() {
        this.rescatarFiscalDataBool = true
    }

}
